import React from 'react';
import Row from 'components/common/Row';
import FilterButton from 'containers/SaleList/components/FilterButton';
import { NoticeFilter, NoticeType } from '../graphQL/types';

interface FilterContainerIProps {
  noticeFilter: NoticeFilter;
  handleSetFilterItem: (key: string, value: any) => void;
}

const FilterContainer: React.FC<FilterContainerIProps> = props => {
  const { noticeFilter, handleSetFilterItem } = props;

  return (
    <Row gap="12px">
      <FilterButton
        isSelected={!noticeFilter.filter.type}
        content="전체"
        onClick={() => {
          handleSetFilterItem('filter', { ...noticeFilter.filter, type: null });
        }}
        style={{
          padding: '10px 12px',
          backgroundColor: !noticeFilter.filter.type ? '#414B56' : '#F7F7F8',
          borderRadius: '10px',
        }}
      />
      <FilterButton
        isSelected={noticeFilter.filter.type === NoticeType.HOST_NOTICE}
        content="공지"
        onClick={() => {
          handleSetFilterItem('filter', {
            ...noticeFilter.filter,
            type: NoticeType.HOST_NOTICE,
          });
        }}
        style={{
          padding: '10px 12px',
          backgroundColor:
            noticeFilter.filter.type === NoticeType.HOST_NOTICE
              ? '#414B56'
              : '#F7F7F8',
          borderRadius: '10px',
        }}
      />
      <FilterButton
        isSelected={noticeFilter.filter.type === NoticeType.HOST_COMMON}
        content="일반"
        onClick={() => {
          handleSetFilterItem('filter', {
            ...noticeFilter.filter,
            type: NoticeType.HOST_COMMON,
          });
        }}
        style={{
          padding: '10px 12px',
          backgroundColor:
            noticeFilter.filter.type === NoticeType.HOST_COMMON
              ? '#414B56'
              : '#F7F7F8',
          borderRadius: '10px',
        }}
      />
      <FilterButton
        isSelected={noticeFilter.filter.type === NoticeType.HOST_EVENT}
        content="이벤트"
        onClick={() => {
          handleSetFilterItem('filter', {
            ...noticeFilter.filter,
            type: NoticeType.HOST_EVENT,
          });
        }}
        style={{
          padding: '10px 12px',
          backgroundColor:
            noticeFilter.filter.type === NoticeType.HOST_EVENT
              ? '#414B56'
              : '#F7F7F8',
          borderRadius: '10px',
        }}
      />
    </Row>
  );
};

export default FilterContainer;
